import { Card } from "primereact/card";
import { QuestionResponse } from "../models";
export default function DefaultResponseComponent({ response, questionText }: { response: QuestionResponse[], questionText: string }) {
    response = response.sort((a, b) => {
        if (a.propertySequence != null && b.propertySequence != null) {
            return a.propertySequence - b.propertySequence;
        }
        return 0;
    });

    return (
        <Card>
            <div className="grid">
                {
                    response.map((response,index) => (
                        response?.fieldName && <>
                            {/* {questionText !== response.fieldName && <div key={index} className="col-6">
                                <span className='p-bold'>{response.fieldName} </span>
                            </div>
                            } */}
                            <div key={questionText+index} className='col-10 word-wrap-break-word'>
                                <span>{response.fieldValue}</span>
                            </div>
                        </>
                    ))
                }
            </div>
        </Card >
    )
} 